export default "__VITE_ASSET__micu9AMb__"